<template>
    <v-row>
      <v-col cols="9" class="d-flex flex-row" v-if="!isItFromTaxMobile">
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="getSelectedTaxType" label="Tax Type" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="editedItem.taxYear" label="Tax Year" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2"
        :value="editedItem.taxId" label="Tax ID" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2" label="Base ID"
      :value="editedItem.baseId" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="editedItem.ownerId" label="Owner ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="3" v-if="!isItFromTaxMobile">
      <v-text-field class="input-text-size pt-0 pb-0" :value="editedItem.propertyOrParcelId"
        label="Property/Parcel ID" readonly tabindex="-1" />
    </v-col>
        <v-col cols="6" class="pt-0 pb-0">
            <CommonDropDowns class="mr-1" :isItTaxYearWithoutAllYears=true v-if="isItFromTaxMobile"
            @change="dataFromCommonDropDowns" :taxYearValue="editedItem.taxYear"
            :isTaxYearWithoutAllDisabled=true />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0">
            <v-text-field class="input-text-size" label="Tax ID" v-model.number="editedItem.taxId"
             readonly tabindex="-1" v-if="isItFromTaxMobile" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Name" v-model="editedItem.name1"
            v-uppercase=globalSettingItem.conEverythingToCaps readonly tabindex="-1" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Parcel ID"
             v-model="editedItem.propertyOrParcelId" :readonly="!isItFromTaxMobile"
             :tabindex="!isItFromTaxMobile ? -1 : 0"
             @blur="formatToPidWithDashes('propertyOrParcelId')"
             @focus="formatToPidWith('propertyOrParcelId'), $event.target.select()"
             v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="VIN #" v-model="editedItem.mhVin" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Year Built"
            v-model.number="editedItem.mhYearBuilt" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Make" v-model="editedItem.mhMake" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Description"
            v-model="editedItem.mhDescription"
            v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Tag" v-model="editedItem.mhTag" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Title" v-model="editedItem.mhTitle"
            v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Price" v-model.number="editedItem.mhPrice"/>
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Location" v-model="editedItem.mhLocation"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Trust Receipt"
            v-model="editedItem.mhTrustReceipt" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
            <v-text-field class="input-text-size" label="Decal" v-model="editedItem.mhDecal" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <ClarionDateControl class='input-text-size mt-4' v-model='editedItem.mhDecalDate'
          label='Decal Date' :isToggle="false" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Tax ID of Real Property"
          v-model.number="editedItem.taxIdOfRealEstate" type="Number" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Adjust/Cert Number"
          v-model.number="editedItem.certNumber" type="Number" />
        </v-col>
        <v-col cols="6" class="pt-0 pb-0 mt-n3">
          <v-text-field class="input-text-size" label="Parcel ID of Real Estate"
          @blur="formatToPidWithDashes('pIdOfRealEstate'), callOnTIdOrPid()"
          v-model="editedItem.pIdOfRealEstate"
          @focus="formatToPidWith('pIdOfRealEstate'), $event.target.select()"
          v-uppercase=globalSettingItem.conEverythingToCaps />
        </v-col>
    </v-row>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import {
  pIdFormat,
} from '../../../../util/shared/vue-global';
import GlobalToCaps from '../../../../util/shared/GlobalToCaps.mixin.vue';

export default {
  mixins: [GlobalToCaps],
  name: 'TaxMobileDialog',
  props: {
    baseCrudKey: {
      type: String,
      default: 'TaxInquiryDialog',
    },
    isItFromTaxMobile: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    ClarionDateControl,
    CommonDropDowns,
  },
  computed: {
    ...mapGetters('base/crud', [
      'isVisible',
      'item',
    ]),
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    isVisibleProp() {
      const visibleFlag = this.isVisible(this.baseCrudKey);
      if (visibleFlag === undefined) {
        return false;
      }
      return visibleFlag;
    },
    getSelectedTaxType() {
      const selVal = (this.TaxTypeEnum || []).find((ft) => ft.name === this.editedItem.taxType);
      if (selVal && selVal.name) return `${selVal.name} - ${selVal.description}`;
      return '';
    },
  },
  watch: {
    isVisibleProp(newVal) {
      if (newVal) {
        this.formatToPidWithDashes('propertyOrParcelId');
        this.formatToPidWithDashes('pIdOfRealEstate');
      }
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    ...mapActions('tax/taxInquires', [
      'getTaxInquires',
    ]),
    ...mapActions(['reAuth', 'custumColrFlashMsg']),
    dataFromCommonDropDowns(val, whichField) {
      this.editedItem[whichField] = val;
    },
    formatToPidWithDashes(val) {
      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const formattedPid = pIdFormat(this.editedItem[val], formatPidPositions);
      this.editedItem[val] = formattedPid;
    },
    formatToPidWith(val) {
      // Parcel ID is readonly rather than disabled off the Tax Mobile screen now, so a plain
      // click still focuses it and fires this. Stripping the dashes out of a box the user
      // cannot edit would leave the value unformatted if the dialog closes before blur.
      // Only the focus direction is gated - the @blur formatter stays open, since the watcher
      // above calls it to lay the dashes back on for display either way.
      if (val === 'propertyOrParcelId' && !this.isItFromTaxMobile) return;
      const formatedPid = (this.editedItem[val] || '').replace(/-/g, '');
      this.editedItem[val] = formatedPid;
    },
    async callOnTIdOrPid() {
      const { pIdOfRealEstate, taxYear } = this.editedItem;
      if (!pIdOfRealEstate) return;
      const criteria = {
        limit: 1,
        skip: 0,
        taxYear: taxYear || 0,
        pIdExactMatch: pIdOfRealEstate || '',
      };
      const retRes = await this.getTaxInquires({ criteria });
      if ((retRes || []).length) {
        const res = retRes[0];
        this.editedItem.baseId = res.baseId;
      } else {
        this.custumColrFlashMsg({ msg: 'Tax record not found' });
      }
    },
  },
};
</script>
